import { render, staticRenderFns } from "./DptCreateModal.vue?vue&type=template&id=019db754&scoped=true"
import script from "./DptCreateModal.vue?vue&type=script&lang=js"
export * from "./DptCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019db754",
  null
  
)

export default component.exports